import StaticPage from "../../src/pages/index";
export default StaticPage;
